import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CaixaFaceDetectada } from './servico-reconhecimento-facial';

export type ModoCameraFacial = 'registro' | 'cadastro' | 'validacao';

@Component({
  selector: 'app-camera-facial',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './camera-facial.component.html',
  styleUrls: ['./camera-facial.component.css']
})
export class CameraFacialComponent {
  @Input() modo: ModoCameraFacial = 'registro';
  @Input() margemSuperior = false;
  @Input() rostoDetectado = false;
  @Input() provaVidaOk = false;
  @Input() capturando = false;
  @Input() mensagem = '';
  @Input() caixaFace?: CaixaFaceDetectada;
  @Input() zoomVisual = 1;
  @Input() exibirCancelar = false;
  @Output() confirmar = new EventEmitter<void>();
  @Output() cancelar = new EventEmitter<void>();

  get textoConfirmar() {
    if (this.modo === 'registro') {
      return 'Confirmar captura facial';
    }
    return this.modo === 'validacao' ? 'Validar face' : 'Confirmar face';
  }

  get exibirConfirmar() {
    return this.modo === 'cadastro';
  }

  get transformacaoZoom() {
    const zoom = Number.isFinite(this.zoomVisual) ? Math.max(1, Math.min(2.25, this.zoomVisual)) : 1;
    return `scale(${zoom})`;
  }
}
